import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { merchantSettlements } from '@/api/client';
import { Empty } from '@/components/empty';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

export const Route = createFileRoute('/m/settlements')({
  component: MerchantSettlements,
});

function MerchantSettlements() {
  const { t } = useTranslation();
  const list = useQuery({
    queryKey: ['merchant-settlements'],
    queryFn: () => merchantSettlements.list({ limit: 100 }),
  });

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">{t('settlements.title')}</h1>
      </header>

      <div className="rounded-md border border-border overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('settlements.cols.uploaded')}</TableHead>
              <TableHead>{t('settlements.cols.psp')}</TableHead>
              <TableHead>{t('settlements.cols.file')}</TableHead>
              <TableHead className="text-right">{t('settlements.cols.rows')}</TableHead>
              <TableHead className="text-right">{t('settlements.cols.matched')}</TableHead>
              <TableHead className="text-right">{t('settlements.cols.mismatch')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list.data?.map((f) => (
              <TableRow key={f.id}>
                <TableCell className="font-mono text-xs whitespace-nowrap">
                  {dayjs(f.created_at).format('MMM D HH:mm')}
                </TableCell>
                <TableCell className="capitalize">{f.psp_code}</TableCell>
                <TableCell className="font-mono text-xs">{f.filename}</TableCell>
                <TableCell className="tabular-nums text-right">{f.row_count}</TableCell>
                <TableCell className="tabular-nums text-right">{f.matched_count}</TableCell>
                <TableCell className="tabular-nums text-right">{f.mismatch_count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {!list.isLoading && list.data?.length === 0 && (
          <Empty title={t('common.none')} className="border-0" />
        )}
      </div>
    </div>
  );
}
